import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {
  AdminJobBoardsVacanciesGetJobVacancyDetailResponse,
  AdminsApi,
  Configuration,
  JobBoardsVacanciesStatusEnum,
} from 'generated/api'
import { axiosDefaultConfig } from 'constants/axios'
import Toast from 'components/toast/Toast'
import { IconChecklistCircle } from 'components/icons'

const axiosConfig = new Configuration(axiosDefaultConfig)
const adminsApi = new AdminsApi(axiosConfig)

export const useJobVacancyDetail = (shouldFetchOnMountFetchJobVacancyDetail = true) => {
  const params = useParams()
  const navigate = useNavigate()
  const { toast, toastContainer } = Toast()
  const [jobVacancyId, setJobVacancyId] = useState('')
  const [fetchStatusJobVacancyDetail, setFetchStatusJobVacancyDetail] = useState<
    'loading' | 'idle' | 'error'
  >('idle')
  const [jobVacancy, setJobVacany] = useState<AdminJobBoardsVacanciesGetJobVacancyDetailResponse>({
    category: {
      code: '',
      name: '',
    },
    location: {
      areaId: '',
      areaName: '',
    },
    quota: 0,
    id: '',
    jobName: '',
    jobDescription: '',
    totalApplicant: 0,
    status: '' as JobBoardsVacanciesStatusEnum,
    wage: {
      minimum: 0,
      maximum: 0,
      unit: '',
    },
    facilities: [],
    terrain: {
      condition: '',
      soilType: '',
      minimumTreeHigh: 0,
    },
    ffb: {
      minimumEstimation: 0,
      maximumEstimation: 0,
      ffbCollectionMethod: '',
      additionalParameter: '',
    },
    images: [],
    createdAtUtc0: 0,
  })

  const [fetchStatusUpdateJobVacancyStatus, setFetchStatusUpdateJobVacancyStatus] = useState<
    'loading' | 'idle'
  >('idle')
  const [isModalUpdateJobVacancyStatusVisible, setIsModalUpdateJobVacancyStatusVisible] =
    useState(false)

  useEffect(() => {
    if (params.jobId) {
      setJobVacancyId(params.jobId)
    }
  }, [params.jobId])

  useEffect(() => {
    if (jobVacancyId && shouldFetchOnMountFetchJobVacancyDetail) fetchJobVacanyDetail()
  }, [jobVacancyId])

  const fetchJobVacanyDetail = async () => {
    try {
      setFetchStatusJobVacancyDetail('loading')
      const response = await adminsApi.adminsJobBoardsVacanciesGetJobVacancyDetail(jobVacancyId)
      setJobVacany(response.data)
      setFetchStatusJobVacancyDetail('idle')
    } catch {
      setFetchStatusJobVacancyDetail('error')
    }
  }

  const handleOnOpenModalUpdateJobVacancyStatus = () => {
    setIsModalUpdateJobVacancyStatusVisible(true)
  }

  const handleOnCancelModalUpdateJobVacancyStatus = () => {
    setIsModalUpdateJobVacancyStatusVisible(false)
  }

  const handleOnUpdateJobVacancyStatus = async () => {
    try {
      setFetchStatusUpdateJobVacancyStatus('loading')
      await adminsApi.adminsJobBoardsVacanciesUpdateStatusJobVacancy(jobVacancyId, {
        status: JobBoardsVacanciesStatusEnum.Inactive,
      })
      setFetchStatusUpdateJobVacancyStatus('idle')
      await toast(
        'Anda berhasil mengubah status pekerjaan menjadi selesai',
        'success',
        <IconChecklistCircle color="white" />,
      )
      setIsModalUpdateJobVacancyStatusVisible(false)
      await fetchJobVacanyDetail()
    } catch {
      await toast('Tidak dapat terhubung ke server, silakan mencoba kembali.', 'danger')
      setFetchStatusUpdateJobVacancyStatus('idle')
    }
  }

  const handleOnEditJobVacancy = async (jobId: string) => {
    navigate('/job-vacancy/edit/' + jobId)
  }

  return {
    jobVacancy,
    toastContainer,
    fetchStatusJobVacancyDetail,
    fetchStatusUpdateJobVacancyStatus,
    isModalUpdateJobVacancyStatusVisible,
    handleOnOpenModalUpdateJobVacancyStatus,
    handleOnCancelModalUpdateJobVacancyStatus,
    handleOnUpdateJobVacancyStatus,
    fetchJobVacanyDetail,
    handleOnEditJobVacancy,
  }
}
